export const COLLECTION_UI_KEY = 'COLLECTION';
export const DIVIDER_STATIC_PROPS = { name: 'minus', color: 'black', size: 'tiny' };
